import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";

// import {
//   createOrderPayload,
//   generateWhatsAppLink,
//   calculateOrderTotals,
//   createPaymentOrder,
//   validateOrder,
// } from "../services/orderService";
import {
  LuMinus,
  LuPlus,
  LuTrash2,
  LuArrowLeft,
  LuShoppingCart,
  LuChevronDown,
  LuChevronUp,
  // LuCheck,
  LuX,
  LuCreditCard,
  LuLoaderCircle,
} from "react-icons/lu";
import "./Cart.css";
import {
  createPayment,
  getProducts,
} from "../../webview/services/productService";

export default function Cart() {
  // const navigate = useNavigate();

  const {
    items,
    removeFromCart,
    updateQty,
    clearCart,
    getSubtotal,
    getTax,
    // getDiscount,
    getPackingCharge,
    getPlatformFee,
    getTotal,
    // coupon,
    // setCoupon,
    serviceType,
    setServiceType,
    instructions,
    setInstructions,
    getItemQty,
    tableNumber,
    setTableNumber,
    roomNumber,
    setRoomNumber,

    restaurantSettings,
    addToCart,
    // setRestaurantSettings,
  } = useCart();

  const [products, setProducts] = useState([]);

  const restaurantId = restaurantSettings?.restaurant_id;
  const maxTables = restaurantSettings?.max_tables ?? 0;

  const lastMinuteProducts = products.filter(
    (p) => p.category === "LAST MINUTES"
  );

  useEffect(() => {
    const fetchProducts = async () => {
      if (!restaurantId) return;

      try {
        const response = await getProducts(restaurantId);

        console.log("Products API response:", response);

        const productList =
          response?.products || response?.data?.products || [];

        console.log("productList API response:", productList);

        setProducts(productList);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, [restaurantId]);

  // console.log('ssetRestaurantSettingset',setRestaurantSettings);

  console.log("From Context:", restaurantSettings, restaurantId);

  const [isBillExpanded, setIsBillExpanded] = useState(true);
  // const [couponInput, setCouponInput] = useState(coupon);
  // const [couponStatus, setCouponStatus] = useState({
  //   applied: false,
  //   message: "",
  // });
  const [validationErrors, setValidationErrors] = useState([]);
  const [tableError, setTableError] = useState("");
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);

  // Extract settings
  const { qsr, service_type } = restaurantSettings || {};

  // Calculate totals
  const subtotal = getSubtotal();
  const tax = getTax();
  // const discount = getDiscount();
  const packingCharge = getPackingCharge();
  const platformFee = getPlatformFee();
  const total = getTotal();

  const handleAddLastMinute = (product) => {
    addToCart({
      item_id: product.item_id,
      item_name: product.item_name,
      price: product.price,
      images: product.images,
      gst: product.gst,
    });
  };

  // ============================================
  // CONDITIONAL RENDERING LOGIC
  // ============================================

  // QSR Mode Check
  const isQsrMode = qsr === true;

  console.log("isdsrMode", isQsrMode);

  // Always show order types
  const showDineInOption = true;
  const showTakeAwayOption = true;

  // ================================
  // UI VISIBILITY LOGIC (FIXED)
  // ================================

  let showTableField = false;
  let showRoomField = false;
  let showInstructions = false;

  // QSR MODE → Hide everything
  if (qsr === true) {
    showTableField = false;
    showRoomField = false;
    showInstructions = false;
  }

  // NON-QSR MODE
  else {
    showInstructions = true;

    if (service_type === "takeaway_dinein" && serviceType === "dine-in") {
      showTableField = true;
    }

    if (
      (service_type === "takeaway_roomservice" ||
        service_type === "roomservice_only") &&
      serviceType === "dine-in"
    ) {
      showRoomField = true;
    }
  }
  // Clear table/room when switching order types or leaving applicable contexts
  useEffect(() => {
    if (!showTableField) {
      setTableNumber("");
      setTableError("");
    }
    if (!showRoomField) {
      setRoomNumber("");
    }
  }, [
    serviceType,
    showTableField,
    showRoomField,
    setTableNumber,
    setRoomNumber,
  ]);

  // ============================================
  // HANDLERS
  // ============================================

  const handleQtyChange = (itemId, delta) => {
    const currentQty = getItemQty(itemId);
    const newQty = currentQty + delta;

    if (newQty <= 0) {
      removeFromCart(itemId);
    } else {
      updateQty(itemId, newQty);
    }
  };

  //   const handleApplyCoupon = () => {
  //     // const result = calculateOrderTotals(items, couponInput);

  //     if (result.isValidCoupon) {
  //       setCoupon(couponInput.toUpperCase());
  //       setCouponStatus({
  //         applied: true,
  //         message: `Coupon applied! You save ₹${result.discount}`,
  //       });
  //     } else {
  //       setCouponStatus({
  //         applied: false,
  //         message: "Invalid coupon code",
  //       });
  //     }
  //   };

  // const handleRemoveCoupon = () => {
  //   setCoupon("");
  //   setCouponInput("");
  //   setCouponStatus({ applied: false, message: "" });
  // };

  //   const handleCheckout = async () => {
  //     // Validate order
  //     // const validation = validateOrder(
  //     //   serviceType,
  //     //   restaurantSettings,
  //     //   tableNumber,
  //     //   roomNumber
  //     // );

  //     if (!validation.isValid) {
  //       setValidationErrors(validation.errors);
  //       window.scrollTo({ top: 0, behavior: "smooth" });
  //       return;
  //     }

  //     setValidationErrors([]);
  //     setIsProcessingPayment(true);

  //     try {
  //       const payload = createOrderPayload(
  //         items,
  //         serviceType,
  //         coupon,
  //         instructions,
  //         total,
  //         tableNumber,
  //         roomNumber,
  //         packingCharge
  //       );

  //       const paymentResult = await createPaymentOrder(payload);

  //       if (paymentResult.success && paymentResult.paymentUrl) {
  //         navigate(paymentResult.paymentUrl, { replace: true });
  //       } else if (!paymentResult.success) {
  //         console.warn(
  //           "Payment creation failed, falling back to WhatsApp:",
  //           paymentResult.error
  //         );
  //         const { url } = generateWhatsAppLink(payload);
  //         window.open(url, "_blank");
  //       }
  //     } catch (error) {
  //       console.error("Error processing order:", error);
  //       const payload = createOrderPayload(
  //         items,
  //         serviceType,
  //         coupon,
  //         instructions,
  //         total,
  //         tableNumber,
  //         roomNumber,
  //         packingCharge
  //       );
  //       const { url } = generateWhatsAppLink(payload);
  //       window.open(url, "_blank");
  //     } finally {
  //       setIsProcessingPayment(false);
  //     }
  //   };

  const handleClearCart = () => {
    if (window.confirm("Are you sure you want to clear the cart?")) {
      clearCart();
      // setCouponInput("");
      // setCouponStatus({ applied: false, message: "" });
      setValidationErrors([]);
    }
  };

  const handleServiceTypeChange = (newServiceType) => {
    setServiceType(newServiceType);
    setValidationErrors([]);
  };

  const createOrderPayload = () => {
    return {
      restaurant_id: restaurantId,

      order_type: serviceType, // dinein / takeaway

      table_number: tableNumber || null,
      room_number: roomNumber || null,
      cooking_instructions: instructions || "",
      items: items.map((item) => ({
        item_id: item.item_id,
        item_name: item.item_name,
        price: item.price,
        quantity: item.qty,
        total: item.price * item.qty,
      })),
      billing: {
        subtotal: getSubtotal(),
        tax: getTax(),
        packing_charge: getPackingCharge(),
        platform_fee: getPlatformFee(),
        total: getTotal(),
      },
    };
  };
  const getProductImage = (item) => {
    if (item.images && item.images.length > 0 && item.images[0]) {
      return item.images[0];
    }
    // return PLACEHOLDER_IMAGE;
  };

  const handlePaymentButton = async () => {
    if (isProcessingPayment) return;

    // Validate table number if required
    if (showTableField && tableError) {
      setValidationErrors(["Please fix table number before proceeding"]);
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    try {
      setIsProcessingPayment(true);
      console.log("🔥 Payment button clicked");

      const payload = createOrderPayload();

      console.log("Order Payload:", payload);

      // const total = getTotal();
      // console.log("Total:", total);

      const data = await createPayment(payload);

      console.log("Returned data:", data);

      if (data?.payment_url) {
        window.location.href = data.payment_url;
      } else {
        alert("Payment URL not received");
        setIsProcessingPayment(false);
      }
    } catch (error) {
      console.error("HANDLE ERROR:", error);
      setIsProcessingPayment(false);
    }
  };
  // ============================================
  // RENDER
  // ============================================

  // Empty cart
  if (items.length === 0) {
    return (
      <div className="cart-container">
        <div className="cart-empty">
          <LuShoppingCart size={64} />
          <h2>Your cart is empty</h2>
          <p>Add some delicious items from our menu!</p>
          <Link
            to={`/partners/${restaurantId}/products`}
            className="browse-menu-btn"
          >
            Browse Menu
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-container">
      {/* Header */}
      <div className="cart-header">
        <Link to={`/partners/${restaurantId}/products`} className="back-link">
          <LuArrowLeft size={20} />
        </Link>
        <h1>Your Cart</h1>
        <button className="clear-cart-btn" onClick={handleClearCart}>
          Clear
        </button>
      </div>

      {/* Validation Errors */}
      {validationErrors.length > 0 && (
        <div className="validation-errors">
          {validationErrors.map((error, index) => (
            <div key={index} className="validation-error">
              <LuX size={16} />
              <span>{error}</span>
            </div>
          ))}
        </div>
      )}

      {/* Cart Content */}
      <div className="cart-content">
        {/* Left: Cart Items */}
        <div className="cart-items-section">
          <h2>Cart Items ({items.length})</h2>

          <div className="cart-items-list">
            {items.map((item) => (
              <div key={item.item_id} className="cart-item">
                <div className="item-image">
                  <img src={getProductImage(item)} alt={item.item_name} />
                </div>

                <div className="item-details">
                  <h3 className="item-name">{item.item_name}</h3>
                  <div className="price-section">
                    <div className="item-price">
                      ₹{item.gst === 1 ? Math.round(item.price) : item.price}
                    </div>
                  </div>
                </div>

                <div className="item-quantity">
                  <div className="qty-controls">
                    <button
                      className="qty-btn"
                      onClick={() => handleQtyChange(item.item_id, -1)}
                    >
                      <LuMinus size={14} />
                    </button>
                    <span className="qty-value">{item.qty}</span>
                    <button
                      className="qty-btn"
                      onClick={() => handleQtyChange(item.item_id, 1)}
                    >
                      <LuPlus size={14} />
                    </button>
                  </div>
                </div>

                <div className="item-subtotal">₹{item.price * item.qty}</div>

                <button
                  className="remove-btn"
                  onClick={() => removeFromCart(item.item_id)}
                  aria-label="Remove item"
                >
                  <LuTrash2 size={18} />
                </button>
              </div>
            ))}
          </div>
          {lastMinuteProducts.length > 0 && (
            <div className="addon-wrapper">
              <h3 className="addon-title">Last Minutes</h3>

              <div
                className={`addon-scroll ${
                  lastMinuteProducts.length > 3
                    ? "scroll-active"
                    : "scroll-hidden"
                }`}
              >
                {lastMinuteProducts.map((product) => (
                  <div key={product.item_id} className="addon-card">
                    <img
                      src={product.images?.[0]}
                      alt={product.item_name}
                      className="addon-img"
                    />

                    <div className="addon-info">
                      <p className="addon-name">{product.item_name}</p>

                      <div className="addon-bottom">
                        <span className="addon-price">₹{product.price}</span>

                        <button
                          className="addon-add"
                          onClick={() => handleAddLastMinute(product)}
                        >
                          ADD +
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Coupon Section */}
          <div className="cart-section coupon-section">
            {/* <h3>Coupon Code</h3> */}
            <div className="coupon-input-group">
              {/* <input
                type="text"
                placeholder="Enter coupon code"
                value={couponInput}
                onChange={(e) => setCouponInput(e.target.value.toUpperCase())}
                disabled={couponStatus.applied}
                className="coupon-input"
              /> */}
              {/* {couponStatus.applied ? (
                <button
                  className="coupon-remove-btn"
                  onClick={handleRemoveCoupon}
                >
                  <LuX size={18} />
                  Remove
                </button>
              ) : (
                <button
                  className="coupon-apply-btn"
                  onClick={handleApplyCoupon}
                  disabled={!couponInput.trim()}
                >
                  Apply
                </button>
              )} */}
            </div>
            {/* {couponStatus.message && (
              <p
                className={`coupon-message ${
                  couponStatus.applied ? "success" : "error"
                }`}
              >
                {couponStatus.applied ? (
                  <LuCheck size={14} />
                ) : (
                  <LuX size={14} />
                )}
                {couponStatus.message}
              </p>
            )}
            <p className="coupon-hint">Try: FIRST10, SAVE20, or FLAT50</p> */}
          </div>

          {/* Service Type Toggle */}
          <div className="cart-section order-type-section">
            <h3>Order Type</h3>
            <div className="order-type-toggle">
              {showDineInOption && (
                <button
                  className={`order-type-btn ${
                    serviceType === "dine-in" ? "active" : ""
                  }`}
                  onClick={() => handleServiceTypeChange("dine-in")}
                >
                  Dine-In
                </button>
              )}
              {showTakeAwayOption && (
                <button
                  className={`order-type-btn ${
                    serviceType === "takeaway" ? "active" : ""
                  }`}
                  onClick={() => handleServiceTypeChange("takeaway")}
                >
                  Take Away
                </button>
              )}
            </div>
          </div>

          {/* Table Number Field - Only for Dine-In with takeaway_dinein service_type */}
          {showTableField && (
            <div className="cart-section table-room-section">
              <h3>
                Table Number <span className="required">*</span>
              </h3>
              <input
                type="text"
                placeholder="Enter table number"
                value={tableNumber}
                onChange={(e) => {
                  const value = e.target.value;
                  setTableNumber(value);

                  if (value === "") {
                    setTableError("");
                    return;
                  }

                  const numValue = parseInt(value, 10);
                  if (isNaN(numValue) || numValue < 0 || numValue > maxTables) {
                    setTableError(
                      `Please enter table numbers 0 to ${maxTables} only`
                    );
                  } else {
                    setTableError("");
                  }
                }}
                className="table-room-input"
              />
              {tableError && (
                <div
                  className="table-error validation-error"
                  style={{ marginTop: "0.5rem" }}
                >
                  <LuX size={16} />
                  <span>{tableError}</span>
                </div>
              )}
            </div>
          )}

          {/* Room Number Field - Only for Dine-In with room service types */}
          {showRoomField && (
            <div className="cart-section table-room-section">
              <h3>
                Room Number <span className="required">*</span>
              </h3>
              <input
                type="text"
                placeholder="Enter room number"
                value={roomNumber}
                onChange={(e) => setRoomNumber(e.target.value)}
                className="table-room-input"
              />
            </div>
          )}

          {/* Cooking Instructions - Only show when qsr is false */}
          {showInstructions && (
            <div className="cart-section instructions-section">
              <h3>
                Cooking Instructions{" "}
                <span className="optional">(Optional)</span>
              </h3>
              <textarea
                placeholder="E.g., Less spicy, no onion, extra sauce..."
                value={instructions}
                onChange={(e) => setInstructions(e.target.value)}
                className="instructions-input"
                rows={3}
              />
            </div>
          )}
        </div>

        {/* Right: Bill Summary */}
        <div className="cart-summary-section">
          <div className="bill-summary">
            <h2>Bill Summary</h2>

            {/* Expandable Bill Details */}
            <div className="bill-details">
              <button
                className="bill-toggle"
                onClick={() => setIsBillExpanded(!isBillExpanded)}
              >
                <span>View Details</span>
                {isBillExpanded ? (
                  <LuChevronUp size={20} />
                ) : (
                  <LuChevronDown size={20} />
                )}
              </button>

              {isBillExpanded && (
                <div className="bill-items">
                  <div className="bill-row">
                    <span>Subtotal</span>
                    <span>₹{subtotal}</span>
                  </div>
                  {tax > 0 && (
                    <div className="bill-row">
                      <span>GST (5%)</span>
                      <span>₹{tax}</span>
                    </div>
                  )}
                  {/* {discount > 0 && (
                    <div className="bill-row discount">
                      <span>Discount</span>
                      <span>-₹{discount}</span>
                    </div>
                  )} */}
                  {/* Packing Charge - Only show for Take Away with charge > 0 */}
                  {serviceType === "takeaway" && packingCharge > 0 && (
                    <div className="bill-row packing-charge">
                      <span>Packing Charge</span>
                      <span>₹{packingCharge}</span>
                    </div>
                  )}
                  {/* Platform Fee */}
                  {platformFee > 0 && (
                    <div className="bill-row platform-fee">
                      <span>Platform Fee</span>
                      <span>₹{platformFee}</span>
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Grand Total */}
            <div className="bill-total">
              <span>Grand Total</span>
              <span>₹{total} </span>
            </div>

            {/* Pay Now Button */}
            <button
              className="pay-now-btn"
              // onClick={handleCheckout}
              onClick={handlePaymentButton}
              disabled={isProcessingPayment || (showTableField && tableError)}
            >
              {isProcessingPayment ? (
                <>
                  <LuLoaderCircle className="spin" size={20} />
                  Processing...
                </>
              ) : (
                <>
                  <LuCreditCard size={20} />
                  Pay Now
                </>
              )}
            </button>

            <p className="order-note">
              You will be redirected to complete your payment
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
